import classNames from 'classnames'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  isActive?: boolean
}

const MixIcon = ({ isActive }: Props): ReactElement => {
  const mixIconClasses = classNames('mix-icon-component', { active: isActive })

  return (
    <div className={mixIconClasses}>
      <span>Mix</span>
    </div>
  )
}

export default MixIcon
